/* eslint-disable react/jsx-pascal-case */
// base_info_view 1 
import React, { useRef, useState, useEffect } from 'react'
import BaseInfoView1_1 from './base_info_view_1_1'
const BaseInfoView1 = ({
    baseInfoView1_1Props = {
        keywordPlaceholder: "關鍵字",
        defaultKeyword: "",
        conditionOptions: { 類別: ["通知信", "簡報"], 狀態: ["草稿", "已發佈"] },
        defaultConditions: {},
        advancedFields: [],
        defaultAdvancedValues: {

        },
        searchButtonText: '查詢',
        showConditionFilter: true,
        showAdvancedButton: true,
        onSearch: () => { },
        onKeywordChange: () => { },
    },
    showComponent = ["BaseInfoView1_1"]
}) => {

    return (<>
        {showComponent.includes("BaseInfoView1_1") && (
            <BaseInfoView1_1
                {...baseInfoView1_1Props}
            />)}
    </>

    )
}
export default BaseInfoView1
